import React from 'react';
import styled from "styled-components";
import SNBCaptionFindReplace from "./Contents/SNBCaptionFindReplace";
import SNBCaptionValidation from "./Contents/SNBCaptionValidation";
import SNBCaptionMove from "./Contents/SNBCaptionMove";


/**
 헤더 레이아웃 (제목, 번역구간, AI 팝업, 저장, 다운로드)

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function SNBBox() {
  return (
    <SNBButtonArea>
      <SNBCaptionFindReplace />
      <SNBCaptionMove/>
      <SNBCaptionValidation />
    </SNBButtonArea>
  );
}

const SNBButtonArea = styled.header`
  .btn {
    position: relative;
    width: 34px;
    height: 34px;
    font-size: 20px;

    + .btn {
      margin-top: 10px;
    }
  }

  .btn.active {
    color: #0a87ff;
  }
`;
